import { LaunchDarklyProject } from '@square/ember-features/protos/squareup/feature/relay/flags/message/launch_darkly_project';

export const LAUNCH_DARKLY_FEATURE_FLAGS = [
  {
    flagName: 'banking/savings_show_fdic_logo',
    project: LaunchDarklyProject.PIE,
  },
  {
    flagName: 'uisystems-market-monochrome',
    project: LaunchDarklyProject.PIE,
  },
];
